import * as React from 'react';
/**
 * Context for providing the IconSubset.
 */
export const IconContext = React.createContext(undefined);
/**
 * Hook to access the Icon subset. Returns the icons that will override the default.
 * This can be overridden contextually using the `IconProvider`.
 */
export const useIconSubset = () => React.useContext(IconContext);
/**
 * Component to contextually override one or more of the default SVG icons
 */
export const IconProvider = props => {
    return React.createElement(IconContext.Provider, { value: props.icons }, props.children);
};
//# sourceMappingURL=IconProvider.js.map